import { tv } from 'tailwind-variants';

import { base } from './base';

import type { ComponentPropsWithRef } from 'react';
import type { VariantProps } from 'tailwind-variants';

const body = tv({
  extend: base,
  base: 'font-inter',
  variants: {
    size: {
      lg: 'text-[1rem] leading-6',
      md: 'text-[0.875rem] leading-5',
      sm: 'text-[0.75rem] leading-4',
      xs: 'text-[0.6875rem] leading-4',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type BodyVariants = VariantProps<typeof body>;

export type BodyProps = ComponentPropsWithRef<'span'> & BodyVariants;

function Body({ className, size, weight, italic, disabled, tracking, ...rest }: BodyProps) {
  return <span className={body({ size, weight, italic, disabled, tracking, class: className })} {...rest} />;
}

export { body, Body };
